export default __webpack_public_path__ + "static/media/profile.972edb68.svg";